package pl.mothdigital.neuronowi.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.*
import com.varabyte.kobweb.silk.style.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import pl.mothdigital.neuronowi.common.resources.*
import pl.mothdigital.neuronowi.common.utils.fixPolishOrphans
import pl.mothdigital.neuronowi.components.text.*
import pl.mothdigital.neuronowi.theme.*

data class PriceItem(
    val service: String,
    val duration: String,
    val price: String
)

val PriceTableStyle = CssStyle {
    base {
        Modifier
            .width(100.percent)
            .border(1.px, LineStyle.Solid, SiteTheme.green._200)
            .borderRadius(0.5.cssRem)
            .overflow(Overflow.Hidden)
    }

    cssRule("th") {
        Modifier
            .backgroundColor(SiteTheme.green._100)
            .color(SiteTheme.green._900)
            .fontWeight(FontWeight.Bold)
            .padding(1.cssRem)
            .textAlign(TextAlign.Left)
    }

    cssRule("td") {
        Modifier
            .padding(1.cssRem)
            .borderTop(1.px, LineStyle.Solid, SiteTheme.green._200)
    }

    cssRule("tr:nth-child(even)") {
        Modifier.backgroundColor(SiteTheme.green._50)
    }

    cssRule("tr:hover") {
        Modifier.backgroundColor(SiteTheme.green._100)
    }
}

@Composable
fun SpecialistPriceTable(
    priceItems: List<PriceItem>,
    modifier: Modifier = Modifier
) {
    Table(
        attrs = PriceTableStyle.toModifier().then(modifier).toAttrs()
    ) {
        Thead {
            Tr {
                Th { Text(StringResources.TABLE_HEADER_SERVICE) }
                Th { Text(StringResources.TABLE_HEADER_DURATION) }
                Th { Text(StringResources.TABLE_HEADER_PRICE) }
            }
        }
        Tbody {
            priceItems.forEach { item ->
                Tr {
                    Td { Text(item.service.fixPolishOrphans()) }
                    Td { Text(item.duration.fixPolishOrphans()) }
                    Td {
                        AppP(
                            modifier = Modifier.margin(0.px),
                            color = SiteTheme.green._900
                        ) {
                            SpanText(item.price.fixPolishOrphans(), Modifier.styleModifier { property("font-weight", "bold") })
                        }
                    }
                }
            }
        }
    }
} 
